module.exports = __webpack_public_path__ + "img/icon_psbank.cc74b539.svg";